export const trainingFeatures = [
  {
    image: '/assets/information/training/raise-arrow.svg',
    title: 'Training Designed to Help Small Businesses',
    description:
      'Train your employees for only $12.50/employee or by  purchasing one of our 4-course bundles for only $40/employee.',
  },
  {
    image: '/assets/information/training/three-courses.svg',
    title: '650 + Courses to Choose From',
    description:
      'Our expansive training library helps us identify and create a customized training program for your business.',
  },
  {
    image: '/assets/information/training/group-learn.svg',
    title: 'Convenient Access - Online, 24/7',
    description:
      'Access to our online training is available 24/7 so your employees can log in when it’s best for your business!',
  },
  {
    image: '/assets/information/training/award.svg',
    title: 'Mitigate Risk & Achieve Maximum Compliance',
    description:
      'Our unique training bundles will strengthen your compliance and could lower your business’ insurance premiums!',
  },
];

export const trainingCarouselItems = [
  {
    image: `/assets/information/training/carousel/protective-training.jpg`,
    title: `Core Protective Training Bundle`,
    body: `With so many high priorities, we know it’s hard for small
    business owners to know what type of training is best to
    protect their business. Don’t worry, we can help! We believe
    our Core Protective Documents provide the necessary foundation
    to protect your business. Training your employees on these
    topics can further mitigate risk, increase your ability to
    defend against some of the most common employment claims, and
    could potentially lower your business’ insurance premiums,
    saving you money and creating a return on your training
    investment.`,
  },
  {
    image: `/assets/information/training/carousel/sexual-harassment.jpg`,
    title: `Sexual Harassment Prevention`,
    body: `Sexual Harassment Prevention training is essential for every
    business. Not only does sexual harassment negatively impact
    your employees, but a claim could also create a serious risk
    to your business! Title VII of the Civil Rights Act of 1964
    prohibits sexual harassment in the workplace and your business
    is responsible for conducting a thorough investigation should
    a claim arise. Our training helps you, your employees and your
    supervisors understand how to identify and respond to sexual
    harassment, minimizing risk to your business.`,
  },
  {
    image: `/assets/information/training/carousel/leadership-management.jpg`,
    title: `Leadership Training Bundle`,
    body: `Did you know that managers and supervisors want the
    opportunity to improve their leadership skills? It’s true!
    We’ve put together a series of courses designed to equip new
    and existing leaders with important information that will help
    them manage your employees in a way that protects your
    business. From FLSA regulations to coaching employees on
    performance to managing attendance, these courses are designed
    to give your managers the tools they need to manage your
    workforce while providing them with the opportunity to be a
    successful leader.`,
  },
  {
    image: `/assets/information/training/carousel/workplace-safety.jpg`,
    title: `Workplace Safety Training Bundle`,
    body: `Every business needs to comply with safety requirements and
    keep employees safe from potential accidents and hazards in
    the workplace. More importantly, all employees need to be (and
    feel) safe at work. From OSHA compliance to basic first aid to
    and active shooter training, our training team has created a
    bundle designed to increase general awareness of safety risks
    and practices for your business. Bambee also offers bundles
    targeted for businesses with employees who drive as part of
    their job, handle food, work in healthcare and many more!`,
  },
  {
    image: `/assets/information/training/carousel/osha.jpg`,
    title: `OSHA`,
    body: `All employers are required to comply with the standards and
    guidelines set forth by the Occupational Safety and Health
    Administration (OSHA) and some businesses are at a higher risk
    of illness or injury due to the nature of their work. Bambee
    offers OSHA courses designed to educate your employees on
    essential general health and safety practices in the
    workplace.`,
  },
  {
    image: `/assets/information/training/carousel/custom-training.jpg`,
    title: `Custom Training Solutions`,
    body: `Bambee now provides over 650 different training courses,
    helping you protect your business, potentially lower your
    insurance premiums, develop your leaders and employees and
    improve safety for your business. From compliance training to
    help defend you against the most common employment claims, to
    compliance training to management training, whatever training
    you need, we’ve got it!`,
  },
];

export const carouselNavLabels = [
  `Core Protective Training`,
  `Sexual Harassment Prevention`,
  `Leadership & Management`,
  `Workplace Safety`,
  `OSHA`,
  `Custom Training Solutions`,
];

export const trainingInfoBlocks = [
  {
    order: 1,
    image: '/assets/information/training/infoBlock/training-required.png',
    title: 'Finally, Your Training Needs Simplified',
    description:
      'Choose from one of our specific bundles or allow us to create a training program that is specific to the needs of your business so you can continue to focus on what’s most important to you - your business!',
  },
  {
    order: 2,
    image: '/assets/information/training/infoBlock/training-video.png',
    title: 'A Single Place To Train Your Team',
    description:
      'Our online training platform provides 24/7 access to employees, so they can take the training when it’s most convenient for you and your business! (Remember, non-exempt employees must record all hours spent on training as hours worked).',
  },
  {
    order: 3,
    image: '/assets/information/training/infoBlock/organizations.png',
    title: 'Full Compliance For Every Industry',
    description:
      'Our training team has created several bundles for unique industries, including transportation, food service and healthcare. With over 650 courses to choose from, we can design something completely unique to your business!',
  },
];
